export default {
      id: "x-close-fill-red-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#x-close-fill-red-usage",
      toString: function () {
        return this.url;
      }
    }